var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootItemCarouselBackButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 36.5,
    rx: 35.5,
    ry: 36.5,
    fill: "#C4C4C4",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 60.25C47.8438 60.25 58.25 49.8438 58.25 37C58.25 24.1562 47.8438 13.75 35 13.75C22.1562 13.75 11.75 24.1562 11.75 37C11.75 49.8438 22.1562 60.25 35 60.25ZM24.3125 38.5938C23.375 37.75 23.375 36.3438 24.3125 35.4062L36.9688 22.75C37.8125 21.9062 39.3125 21.9062 40.1562 22.75L41.75 24.3438C42.5938 25.1875 42.5938 26.5938 41.75 27.5312L32.1875 37L41.75 46.5625C42.5938 47.4062 42.5938 48.9062 41.75 49.75L40.1562 51.3438C39.3125 52.1875 37.9062 52.1875 36.9688 51.3438L24.3125 38.5938Z",
    fill: "white",
    fillOpacity: 0.88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootItemCarouselBackButton);
export default __webpack_public_path__ + "static/media/FootItemCarouselBackButton.fee20d12ba0d435205cad42c7d6825dc.svg";
export { ForwardRef as ReactComponent };